import { Button } from "src/elements";
import { downloadFile } from "src/utils";
import { useStatusModal } from "src/modals/StatusModal/store/hooks";

interface Props {
  algoRequest: unknown | null;
  algoResponse: unknown | null;
  error: string | null;
  s2SolutionId?: number;
}

export const S2QuadLogsButton = ({ algoRequest, algoResponse, error, s2SolutionId }: Props) => {
  const { openStatusModal } = useStatusModal();

  const downloadLogs = (logsType: "algo_request" | "algo_response") => {
    const data = logsType === "algo_request" ? algoRequest : algoResponse;
    if (data !== null && data !== undefined) {
      const filename = s2SolutionId
        ? `s2_${logsType}_${s2SolutionId}`
        : `s2_${logsType}_${Date.now()}`;
      downloadFile({
        name: filename,
        extension: "json",
        data: JSON.stringify(data, null, 2),
      });
    }
  };

  const handleErrorDetails = () => {
    if (error !== null && error !== undefined) {
      openStatusModal({
        title: "Error details",
        content: error,
      });
    }
  };

  const hasLogs =
    algoRequest !== null || algoResponse !== null || (error !== null && error !== undefined);
  const hasRequest = algoRequest !== null && algoRequest !== undefined;
  const hasResponse = algoResponse !== null && algoResponse !== undefined;
  const hasError = error !== null && error !== undefined;

  return (
    <Button
      size="small"
      color="greenSmoke"
      variant="inverted"
      isDisabled={!hasLogs}
      dropdown={[
        {
          label: "S2 Request",
          onClick: () => downloadLogs("algo_request"),
          isDisabled: !hasRequest,
        },
        {
          label: "S2 Response",
          onClick: () => downloadLogs("algo_response"),
          isDisabled: !hasResponse,
        },
        {
          label: "Error details",
          onClick: handleErrorDetails,
          isDisabled: !hasError,
        },
      ]}
    >
      Logs
    </Button>
  );
};
